import React from 'react';
import BaseActionForm from '../BaseActionForm';
// import { Button, Dropdown, Form, Row, Col } from "react-bootstrap";
// import ApiService from "../../services/ApiService";

class Tarifs extends BaseActionForm {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,

        }
    }

    async componentDidMount() {
        super.componentDidMount();

        /*this.startLoading();
        let response = await Promise.all([
            ApiService.getObjects("rk_metadata", "regionState", null, { region: 1, code: 1 }),
            ApiService.getObjects("rk_metadata", "regionBlocks")
        ])
        this.stopLoading();
        if (this.checkStatus(response)) {
            this.setState({
                regionState: response[0].objects,
                regionBlocks: response[1].objects
            });
        }*/
    }
    /*
        handleRegionSelect = (region) => {
            this.setState({
                selectedRegion: region
            });
        }
    */

    render() {

        return (
            <div id={"tarifs"} className={"flexColumn rightPanel"}>
                <h3 className="headerMargin">Тарифы</h3>

                {this.renderAlerts()}

                {/*this.state.regionState &&
                    <Dropdown className="dropdown">
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                            {this.state.selectedRegion ? this.state.selectedRegion.region : "выберите регион"}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {this.state.regionState.map((region, index) => (
                                <Dropdown.Item key={index} onClick={() => {
                                    this.handleRegionSelect(region);
                                }}>{region.region}</Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                            */}
                {/*
                <Dropdown className="dropdown">
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                        {this.state.selectedVersion ? this.state.selectedVersion.label : "выберите версию алгоритма"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {this.versions.map((version, index) => (
                            <Dropdown.Item key={index} onClick={() => {
                                this.handleVersionSelect(version);
                            }}>{version.label}</Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>

                        */  }

                {this.state.message}
            </div>
        );
    }
}

export default Tarifs;
